import { EpicWithStatus } from '../interfaces/epic.interface'

/**
 * Las dos reglas de F-037, en un solo sitio porque las consumen **dos pantallas distintas** y tenían
 * que decir lo mismo.
 *
 * Que sean dos no es un capricho de la interfaz: una épica **sin tareas no aparece en el Mapa de
 * trabajo**. El Gantt solo dibuja las que arrancaron (`worklog-gantt`: filtra por `startedAt`) y el
 * Backlog solo agrupa las que tienen trabajo en cola. La única pantalla donde se ve una épica vacía
 * es **Métricas** — que es, justamente, donde hay que poder retirarla. Dejar el retiro solo en la
 * ficha del Mapa de trabajo lo habría puesto donde el caso que motivó la tarea nunca se ve.
 */

/** Retirar es del equipo (`isDev`, igual que el backend) y solo si no hay trabajo colgando. */
export function puedeRetirarEpica(row: EpicWithStatus | null, isDev: boolean): boolean {
	return isDev && !!row && row.taskCount === 0
}

/**
 * El motivo cuando NO se puede, para enseñarlo en vez de un botón deshabilitado: uno deshabilitado
 * deja a quien lo mira peleándose con él para averiguar por qué. `null` cuando sí se puede, y
 * también para quien no es del equipo — a esa persona no le falta un permiso, le sobra un botón.
 */
export function motivoNoRetirarEpica(row: EpicWithStatus | null, isDev: boolean): string | null {
	if (!isDev || !row || row.taskCount === 0) return null
	const n = row.taskCount
	return `Primero hay que mover o cerrar sus ${n} tarea${n === 1 ? '' : 's'}: al retirarla se quedarían sin épica a la que pertenecer.`
}
